import {IssueTypeToken} from '@github-ui/issue-type-token'

import type {IssueSecondaryRepositoryNode} from './header-issue-type-query-types'
import styles from './HeaderIssueType.module.css'

export type HeaderIssueTypeFragment = {
  readonly repository: Pick<IssueSecondaryRepositoryNode, 'nameWithOwner'>
  readonly issueType: {readonly name: string; readonly color: string} | null
}

export type HeaderIssueTypeProps = {
  data: HeaderIssueTypeFragment
}

export function HeaderIssueType({data: {issueType, repository}}: HeaderIssueTypeProps) {
  if (!issueType) return null

  const getTooltipText = (isTextTruncated: boolean) => {
    return isTextTruncated ? issueType.name : undefined
  }

  return (
    <IssueTypeToken
      name={issueType.name}
      color={issueType.color}
      href={`/${repository.nameWithOwner}/issues?q=type:"${issueType.name}"`}
      getTooltipText={getTooltipText}
      size="large"
      className={styles.IssueTypeToken}
    />
  )
}

export const SmallHeaderIssueType = ({data: {issueType}}: HeaderIssueTypeProps) => {
  if (!issueType) return null

  return <div className={styles.smallToken}>{issueType.name}</div>
}
